import Trades from "./tabview/Trade";
import History from "./tabview/History";
import { CiCircleList } from "react-icons/ci";
import { BsJournals } from "react-icons/bs";
import { IoMailOutline } from "react-icons/io5";
import { IoIosNotificationsOutline } from "react-icons/io";
import { VscHistory } from "react-icons/vsc";
import { PiTreeViewLight } from "react-icons/pi";
import { HiOutlineNewspaper } from "react-icons/hi2";
import Alert from "../tab/tabview/alert/Alert.jsx";
import Mail from "../tab/tabview/mail/Mail.jsx";
import News from "./tabview/News";
import Report from './tabview/reports/Report.jsx'
import AccountTree from "./tabview/AccountTree.jsx";
import { BsBookmarks } from "react-icons/bs";
import Orders from "./tabview/order/Orders.jsx";
import { IoNewspaperOutline } from "react-icons/io5";


const data = []
const TabName = [
  {
    id: 1, name: "trade", icon: <CiCircleList />,
    component: (handleOpenTradeModal, handleOpenModifyPositionModal, handleChartFromTradeTabClick) => <Trades data={data} loading={false} handleOpenTradeModal={handleOpenTradeModal} handleOpenModifyPositionModal={handleOpenModifyPositionModal} handleChartFromTradeTabClick={handleChartFromTradeTabClick} />,
  },
  // { id: 2, name: "order", icon: <BsBookmarks />, component: <Orders data={data} />, },
  { id: 2, name: "history", icon: <VscHistory />, component: <History data={data} />, },
  { id: 3, name: "alerts", icon: <IoIosNotificationsOutline style={{ fontSize: 25 }} />, component: <Alert data={data} />, },
  { id: 4, name: "mailBox", icon: <IoMailOutline />, component: <Mail data={data} />, },
  { id: 5, name: "report", icon: <BsJournals />, component: <Report />, },
  { id: 6, name: "news", icon: <IoNewspaperOutline />, component: <News data={data} />, },
  { id: 7, name: "accounts", icon: <PiTreeViewLight />, component: (setSelectedTab) => <AccountTree setSelectedTab={setSelectedTab} />, },
];

export default TabName;
